import {useQuery} from "@tanstack/react-query";
import {getMe} from "@/api/auth";
import {getSubscription, listPaymentMethods, listPlans, listSubscriptionPayments,} from "@/api/billing";
import {hasPaidAccess} from "@/lib/cabinet";

export function useCabinetData() {
    const meQuery = useQuery({
        queryKey: ["cabinet", "me"],
        queryFn: getMe,
    });

    const subscriptionQuery = useQuery({
        queryKey: ["cabinet", "subscription"],
        queryFn: getSubscription,
    });

    const plansQuery = useQuery({
        queryKey: ["cabinet", "plans"],
        queryFn: listPlans,
    });

    const paymentsQuery = useQuery({
        queryKey: ["cabinet", "payments"],
        queryFn: () => listSubscriptionPayments(5),
    });

    const paymentMethodsQuery = useQuery({
        queryKey: ["cabinet", "payment-methods"],
        queryFn: listPaymentMethods,
    });

    const subscription = subscriptionQuery.data?.subscription ?? null;
    const paid = hasPaidAccess(subscription?.status);

    return {
        me: meQuery.data ?? null,
        subscription,
        plans: plansQuery.data?.plans ?? [],
        payments: paymentsQuery.data?.payments ?? [],
        paymentMethods: paymentMethodsQuery.data?.payment_methods ?? [],
        paid,
        isLoading:
            meQuery.isLoading ||
            subscriptionQuery.isLoading ||
            plansQuery.isLoading,
        isError:
            meQuery.isError ||
            subscriptionQuery.isError ||
            plansQuery.isError,
        refetch: async () => {
            await Promise.all([
                meQuery.refetch(),
                subscriptionQuery.refetch(),
                plansQuery.refetch(),
                paymentsQuery.refetch(),
                paymentMethodsQuery.refetch(),
            ]);
        },
    };
}
